export var ChatbotUserRole;
(function (ChatbotUserRole) {
    ChatbotUserRole["USER"] = "USER";
    ChatbotUserRole["ASSISTANT"] = "ASSISTANT";
    ChatbotUserRole["SYSTEM"] = "SYSTEM";
})(ChatbotUserRole || (ChatbotUserRole = {}));
